export default __webpack_public_path__ + "static/media/template-default-image.55ea9ed2.png";